import styled from 'styled-components';
import { Overlay } from '@/components/UI/Overlay';

export const SearchPanelOverlay = styled(Overlay)`
  transition: none;
  z-index: 9;

  @media (min-width: 950px) {
    z-index: 11;
  }
`;
